import { all, fork } from 'redux-saga/effects';
import externalSagas from './externalSagas';

export default function* socketsSaga() {
  yield all([fork(externalSagas)]);
}
